import { emptyFragment, Menu, useOpenable, VerticalDotsIcon } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { useState } from 'react';
import { findLinkBy } from '../../../../Links';
import ProgramStore from '../../../../ProgramStore';
import { ProgramDetailResource } from '../../../../ProgramStore/Types';
import { T } from '../../../../Translations';
import { Typography } from '../../../UI';
import ConfirmProgramDrop from './ConfirmProgramDrop';

interface Props {
  programDetailResource: ProgramDetailResource;
  programStore: ProgramStore;
}

function ProgramDropping({ programDetailResource, programStore }: Props) {
  const { onOpen, isOpen, onClose } = useOpenable();
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  const handleDropProgram = () => {
    setMenuOpen(false);
    onOpen();
  };

  return (
    <>
      {findLinkBy({ rel: 'dropping-program' }, programStore.programLinks)
        .map(() => (
          <>
            <button
              type="button"
              onClick={handleMenuOpen}
              className="m-0 border-0 bg-transparent p-0"
              aria-label="Program options"
            >
              <VerticalDotsIcon className="cursor-pointer" />
            </button>
            <Menu
              anchorElement={anchorElement}
              open={menuOpen}
              onClose={handleMenuClose}
              placement="bottom-end"
            >
              <Menu.Item onClick={handleDropProgram}>
                <Typography color="dark" variant="body2" fontWeight="medium">
                  <T kind="Drop Program" />
                </Typography>
              </Menu.Item>
            </Menu>
          </>
        ))
        .getOrElse(emptyFragment)}
      <ConfirmProgramDrop
        isOpen={isOpen}
        onClose={onClose}
        programStore={programStore}
        programDetailResource={programDetailResource}
      />
    </>
  );
}
export default observer(ProgramDropping);
